import {
  CLEAR_SERIE_DATA,
  FETCH_CONTENT_SERIES_REQUEST_ERROR,
  FETCH_CONTENT_SERIES_REQUEST_INIT,
  FETCH_CONTENT_SERIES_REQUEST_SUCCESS,
  HIDE_MENU_SERIES,
  HIDE_VOD_TRANSACTIONS_MODAL,
  SET_SEASON_SELECTED,
  SHOW_MENU_SERIES,
  SHOW_VOD_TRANSACTIONS_MODAL,
  SHOW_VOD_ANONYMOUS_MODAL,
  SET_EPISODE_INFO,
} from 'containers/Player/actions/series/constants';

const initialState = {
  data: null,
  loading: false,
  error: null,
  seasonSelected: null,
  loadingMoreData: true,
  vodTransactionsModal: {
    show: false,
    pbi: null,
  },
  seriesMenu: {
    show: false,
  },
  showVodAnonymousModal: false,
  episodeInfo: '',
  dataSeriesLastEpisodeAndseason : {
    id: null,
    group_id:null,
    last_episode: null,
    last_season: null
  }
};

const SeriesReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CONTENT_SERIES_REQUEST_INIT:
      return {
        ...initialState,
        loading: true,
        seriesMenu: state.seriesMenu,
        vodTransactionsModal: state.vodTransactionsModal,
        dataSeriesLastEpisodeAndseason : {
          id: null,
          group_id:null,
          last_episode: null,
          last_season: null
        }
      };
    case FETCH_CONTENT_SERIES_REQUEST_SUCCESS:
      return {
        ...state,
        data: action.data,
        loading: false,
        seasonSelected: action.seasonSelected
          ? action.seasonSelected
          : state.seasonSelected,
        loadingMoreData: action.loadingMoreData,
        dataSeriesLastEpisodeAndseason: action?.dataSeriesLastEpisodeAndseason,
      };
    case FETCH_CONTENT_SERIES_REQUEST_ERROR:
      return {
        ...initialState,
        error: action.error,
        vodTransactionsModal: state.vodTransactionsModal,
        dataSeriesLastEpisodeAndseason : {
          id: null,
          group_id:null,
          last_episode: null,
          last_season: null
        },
      };
    case SET_SEASON_SELECTED:
      return {
        ...state,
        seasonSelected: action.seasonSelected
          ? action.seasonSelected
          : state.seasonSelected,
        loadingMoreData: action.loadingMoreData,
      };
    case CLEAR_SERIE_DATA:
      return {
        ...initialState,
        vodTransactionsModal: state.vodTransactionsModal,
      };
    case SHOW_VOD_TRANSACTIONS_MODAL:
      return {
        ...state,
        vodTransactionsModal: { show: true, pbi: action.payload },
      };
    case HIDE_VOD_TRANSACTIONS_MODAL:
      return {
        ...state,
        vodTransactionsModal: { show: false, pbi: null },
      };
    case SHOW_MENU_SERIES:
      return {
        ...state,
        seriesMenu: {
          show: true,
        },
      };
    case HIDE_MENU_SERIES:
      return {
        ...state,
        seriesMenu: {
          show: false,
        },
      };
    case SHOW_VOD_ANONYMOUS_MODAL:
      return {
        ...state,
        showVodAnonymousModal: action.payload,
      };
    case SET_EPISODE_INFO:
      return {
        ...state,
        episodeInfo: action.payload,
      };
    default:
      return state;
  }
};

export default SeriesReducer;
